import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranService, TranType } from '../../services/tran.service';
import { WarehouseService } from '../../services/warehouse.service';
import { InAndOutService } from '../../services/in-and-out.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { CustomerBillService } from '../../services/customer-bill.service';
import { RemissionService } from '../../services/remission.service';
import { PurchaseOrderId, PurchaseOrderService } from '../../services/purchase-order.service';
import { CustomerSupplierId } from '../../services/customer-supplier.service';

@Component({
  selector: 'app-display-tran',
  templateUrl: './display-tran.component.html',
  styleUrls: ['./display-tran.component.css']
})
export class DisplayTranComponent implements OnInit, OnDestroy {
  transaction: any = [];

  id: string;
  billFolio: string = '';
  remFolio: string = '';

  sub: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private tranService: TranService,
    private warehouseService: WarehouseService,
    private inAndOutService: InAndOutService,
    private billService: CustomerBillService,
    private remService: RemissionService,
    private odcService: PurchaseOrderService,
    private afh: FirestoreService,
  ) {

    this.id = this.activatedRoute.snapshot.paramMap.get('idTran');

    this.sub = this.tranService.getTransaction(this.id).subscribe(transactionObj => {
      this.transaction = transactionObj;
      this.transaction.warehouseName = transactionObj.warehouseObj.name;
      this.transaction.inOutName = transactionObj.inOutTypeObj.description;
      this.transaction.inOutType = transactionObj.inOutTypeObj.type == 'in' ? 'entrada' : 'salida';
      this.billFolio = transactionObj.billFolio || '';
      /* if(transactionObj.billRef){
        let billSub = this.billService.getCustomerBill(transactionObj.billRef.id).subscribe(([bill]) => {
          billSub.unsubscribe();
          this.billFolio = bill.folio;
        });
      } */
      if(transactionObj.remRef){
        let remSub = this.remService.getRemission(transactionObj.remRef.id).subscribe(([rem]) => {
          remSub.unsubscribe();
          this.remFolio = rem.folio;
        });
      }
      this.transaction.date = moment(this.transaction.createdAt).format('YYYY-MM-DD HH:ss');

      this.retrieveNames();
    });
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  async retrieveNames(){
    function doc(path, service: FirestoreService): Promise<any>{
      return new Promise((resolve => {
        let sub = service.docWithIds$(path).subscribe(pr => {
          sub.unsubscribe()
          resolve(pr);
        });
      }));
    }
    let prNames: {[path: string]: string} = {};
    let odcFolios: {[id: string]: PurchaseOrderId['folio']} = {};
    let supNames: {[odcId: string]: CustomerSupplierId['name']} = {};
    for(let pr of this.transaction.prInTransaction){
      if(prNames[pr.ref.path]) pr.name = prNames[pr.ref.path];
      else{
        let prDoc = await doc(pr.ref.path, this.afh);
        prNames[pr.ref.path] = pr.name = prDoc.name;
      }
      if(pr.odcId){
        if(odcFolios[pr.odcId]){
          pr.odcName = odcFolios[pr.odcId];
          pr.supName = supNames[pr.odcId];
        }else{
          let odc = await this.afh.docWithId<PurchaseOrderId>(`${this.odcService.collection}/${pr.odcId}`);
          if(!odc) continue;
          let sup = await this.afh.docWithId<CustomerSupplierId>(odc.supplierId.path);
          odcFolios[pr.odcId] = pr.odcName = odc.folio;
          supNames[pr.odcId] = pr.supName = sup && sup.name || '';
        }
      }
    }
  }

  returnInAndOuts(){
    if(this.transaction.type == TranType.In){
      this.router.navigate(['/in_tran/']);
    } else {
      this.router.navigate(['/out_tran/']);
    }
  }

}
